import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CCardComponent } from './c-card.component';

@NgModule({
  declarations: [CCardComponent],
  imports: [CommonModule],
  exports: [CCardComponent],
})
export class CCardModule {}
